export default __webpack_public_path__ + "static/media/update.67b80c6a.png";